export default __webpack_public_path__ + "static/media/Sicov.54d68efc.png";